import { tget, tpost } from '../../utils/Utils/Utils';

export function actionEquipmentFetchAll() {
  return (dispatch) =>
    tget('/api/v3/torga/equipment').then((result) => {
      dispatch({ type: 'EQUIPMENT_FETCH_COMPLETE', payload: result });
    });
}

export function actionEquipmentCreate(name) {
  return (dispatch) =>
    tpost('/api/v3/torga/equipment', { name }).then((result) => {
      dispatch({ type: 'EQUIPMENT_FETCH_COMPLETE', payload: [result] });
    });
}

export function actionEquipmentUpdate(id, field, value) {
  return (dispatch) =>
    tpost(`/api/v3/torga/equipment/${id}/${field}`, { [field]: value }).then(
      (result) => {
        dispatch({ type: 'EQUIPMENT_PERSIST_COMPLETE', payload: [result] });
      }
    );
}

export function actionActivityEquipmentFetchAll() {
  return (dispatch) =>
    tget('/api/v3/torga/activityequipment').then((result) => {
      dispatch({ type: 'ACTIVITYEQUIPMENTS_FETCH_COMPLETE', payload: result });
    });
}

export function actionActivityEquipmentSet(activity_id, equipment_id, deleted) {
  return (dispatch) =>
    tpost('/api/v3/torga/activityequipment', {
      activity_id,
      equipment_id,
      deleted,
    }).then((result) => {
      dispatch({
        type: deleted ? 'ACTIVITYEQUIPMENTS_REMOVE' : 'ACTIVITYEQUIPMENTS_ADD',
        payload: [result],
      });
    });
}
